<div class="container">
   <div class="row">
      <div class="col">
         <div class="delivery d-flex justify-content-center mt-3 mb-5">
            <div class="delivery-description d-flex justify-content-center">
               <button class="btn btn-outline-info text-dark" routerLink="/public/landing-page">
                  <i class="bi bi-arrow-left-short"></i>{{ 'buttons.back' | translate | titlecase }}
               </button>

               <div class="delivery-description__block d-flex flex-column">
                  <h5 class="delivery-description__title">{{ translatePath + 'title' | translate }}</h5>
                  <span class="delivery-description__text">{{ translatePath + 'steps' | translate }}</span>
               </div>
            </div>
         </div>

         <div class="steps d-flex align-content-around">
            <div class="steps-container d-flex align-items-center justify-content-center">
               <img src="./../../../assets/images/to-add-delivery/1.svg" class="steps-container__img" />
               <div class="steps-container__num d-flex align-items-center justify-content-center ml-3">
                  <span>1</span>
               </div>
            </div>
            <div class="steps-text d-flex ml-5 align-items-center">
               <span class="steps-text__about ml-3 pl-3">{{ translatePath + 'step1' | translate }}</span>
            </div>
            <img src="./../../../assets/images/to-add-delivery/linie_stanga.svg" class="steps-img1" />
         </div>

         <div class="steps d-flex align-content-around bg-white">
            <div class="steps-container d-flex align-items-center flex-row-reverse ml-5">
               <img src="./../../../assets/images/to-add-delivery/2.svg" class="steps-container__img" />
               <div class="steps-container__num d-flex align-items-center justify-content-center mr-3">
                  <span>2</span>
               </div>
            </div>
            <div class="steps-text d-flex ml-5 align-items-center">
               <span class="steps-text__about">{{ translatePath + 'step2' | translate }}</span>
            </div>
            <img src="./../../../assets/images/to-add-delivery/linie_dreapta.svg" class="steps-img2" />
         </div>

         <div class="steps d-flex align-content-around">
            <div class="steps-container d-flex align-items-center justify-content-center">
               <img src="./../../../assets/images/to-add-delivery/3.svg" class="steps-container__img" />
               <div class="steps-container__num d-flex align-items-center justify-content-center ml-3">
                  <span>3</span>
               </div>
            </div>
            <div class="steps-text d-flex ml-5 align-items-center">
               <span class="steps-text__about pl-3 ml-3">{{ translatePath + 'step3' | translate }}</span>
            </div>
            <img src="./../../../assets/images/to-add-delivery/linie_stanga.svg" class="steps-img1" />
         </div>

         <div class="steps d-flex align-content-around bg-white">
            <div class="steps-container d-flex align-items-center flex-row-reverse ml-5">
               <img src="./../../../assets/images/to-add-delivery/4.svg" class="steps-container__img" />
               <div class="steps-container__num d-flex align-items-center justify-content-center mr-3">
                  <span>4</span>
               </div>
            </div>
            <div class="steps-text d-flex ml-5 align-items-center">
               <span class="steps-text__about">{{ translatePath + 'step4' | translate }}</span>
            </div>
            <img src="./../../../assets/images/to-add-delivery/linie_dreapta.svg" class="steps-img2" />
         </div>

         <div class="steps d-flex align-content-around">
            <div class="steps-container d-flex align-items-center justify-content-center">
               <img src="./../../../assets/images/to-add-delivery/5.svg" class="steps-container__img" />
               <div class="steps-container__num d-flex align-items-center justify-content-center ml-3">
                  <span>5</span>
               </div>
            </div>
            <div class="steps-text d-flex ml-5 align-items-center">
               <span class="steps-text__about pl-3 ml-3">{{ translatePath + 'step5' | translate }}</span>
            </div>
            <img src="./../../../assets/images/to-add-delivery/linie_stanga.svg" class="steps-img1" />
         </div>

         <div class="steps d-flex align-content-around bg-white">
            <div class="steps-container d-flex align-items-center flex-row-reverse ml-5">
               <img src="./../../../assets/images/to-add-delivery/6.svg" class="steps-container__img" />
               <div class="steps-container__num d-flex align-items-center justify-content-center mr-3">
                  <span>6</span>
               </div>
            </div>
            <div class="steps-text d-flex ml-5 align-items-center">
               <span class="steps-text__about">{{ translatePath + 'step6' | translate }}</span>
            </div>
         </div>

         <div class="mpass d-flex justify-content-center">
            <div class="mpass-container d-flex flex-column justify-content-center">
               <div class="mpass-header d-flex flex-column justify-content-center align-items-center">
                  <div class="header-container d-flex mt-5">
                     <div style="min-width: 39px">
                        <div class="mpass-header__num d-flex align-items-center justify-content-center mt-1">
                           <span>!</span>
                        </div>
                     </div>

                     <p class="mpass-header__text ml-3">
                        {{ translatePath + 'suggest' | translate }}
                     </p>
                  </div>
                  <h5 class="mpass-header__title mt-3">{{ translatePath + 'signature' | translate }}</h5>
               </div>
               <div class="mpass-container__items d-flex justify-content-center align-items-center mt-4 mb-3 flex-wrap">
                  <div
                     class="mpass-container__items--item d-flex flex-column justify-content-around pt-3 pl-3 pr-3 ml-3"
                  >
                     <h5>{{ translatePath + 'mobile-sign' | translate }}</h5>
                     <p>{{ translatePath + 'mobile' | translate }}</p>
                     <img src="./../../../assets/images/to-add-delivery/semnatura%20mob.svg" />
                  </div>
                  <div
                     class="mpass-container__items--item d-flex flex-column justify-content-around pt-3 pl-3 pr-3 ml-3"
                  >
                     <h5>{{ translatePath + 'electronic-sign' | translate }}</h5>
                     <p>{{ translatePath + 'electronic1' | translate }}</p>
                     <img src="./../../../assets/images/to-add-delivery/semnatura%20electr.svg" />
                  </div>
                  <!--
                  <div class="mpass-container__items--item d-flex flex-column justify-content-around pt-3 pl-3 pr-3">
                     <h5>{{translatePath+'electronic-id' | translate}}</h5>
                     <p>{{translatePath+'electronic2' | translate}}</p>
                     <img src="./../../../assets/images/to-add-delivery/buletin%20ident.svg" />
                  </div>-->
               </div>
               <div class="mpass-container__items d-flex mt-5">
                  <div style="min-width: 39px">
                     <div class="mpass-header__num d-flex align-items-center justify-content-center mt-1">
                        <span>!</span>
                     </div>
                  </div>
                  <p class="mpass-header__text ml-3">
                     {{ translatePath + 'signature-got' | translate }}
                     <a href="https://mpass.gov.md/" target="_blank">mpass.gov.md</a>.
                  </p>
               </div>
            </div>
         </div>
         <div class="height"></div>
      </div>
   </div>
</div>
